// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3k1uR","row":"Node_row__24dxH","label":"Node_label__3LHSa","footer":"Node_footer__2I4X1"};